module.exports = __webpack_public_path__ + "img/iphone-rfidcard-NETHERLANDS-en.c4bb9ca6.webp";